import React from 'react';
import { useParams, useLocation, useNavigate, useMatch } from 'react-router-dom';

function withRouter(Component, pathPattern) {
  function ComponentWithRouterProp(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch(pathPattern || `${location.pathname}/*`); // Default pattern based on current path

    return (
      <Component
        {...props}
        params={params}
        location={location}
        navigate={navigate}
        match={match}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
